import React, { useState } from 'react';

const AdminInsertUser = ({ API_BASE_URL }) => {
    const [form, setForm] = useState({ groupId: '', userId: '', userName: '', linkKey: '' });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const generateLinkKey = () => {
        const uuid = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2) + Date.now().toString(36);
        setForm((prev) => ({ ...prev, linkKey: uuid }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.groupId || !form.userId || !form.userName || !form.linkKey) {
            setMessage({ type: 'error', text: '모든 항목을 입력해주세요.' });
            return;
        }
        setLoading(true);
        setMessage({ type: '', text: '' });
        try {
            const token = localStorage.getItem('admin_token');
            const res = await fetch(`${API_BASE_URL}/api/admin/insert-user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(form),
            });
            const data = await res.json();
            if (data.success) {
                setMessage({ type: 'success', text: '회원 등록 완료!' });
                setForm({ groupId: '', userId: '', userName: '', linkKey: '' });
            } else {
                setMessage({ type: 'error', text: data.message || '등록 실패' });
            }
        } catch (e) {
            setMessage({ type: 'error', text: '서버 오류가 발생했습니다.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={S.wrap}>
            <div style={S.card}>
                <h2 style={S.title}>회원 등록</h2>

                {message.text && (
                    <div style={message.type === 'success' ? S.successBox : S.errorBox}>{message.text}</div>
                )}

                <form onSubmit={handleSubmit} style={S.form}>
                    <div style={S.field}>
                        <label style={S.label}>업체코드 (groupId)</label>
                        <input name="groupId" value={form.groupId} onChange={handleChange} placeholder="업체코드를 입력하세요" style={S.input} />
                    </div>
                    <div style={S.field}>
                        <label style={S.label}>사용자 계정 (userId)</label>
                        <input name="userId" value={form.userId} onChange={handleChange} placeholder="사용자 계정을 입력하세요" style={S.input} />
                    </div>
                    <div style={S.field}>
                        <label style={S.label}>이름 (userName)</label>
                        <input name="userName" value={form.userName} onChange={handleChange} placeholder="이름을 입력하세요" style={S.input} />
                    </div>
                    <div style={S.field}>
                        <label style={S.label}>LinkKey</label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <input name="linkKey" value={form.linkKey} onChange={handleChange} placeholder="LinkKey를 입력하세요" style={{ ...S.input, flex: 1 }} />
                            <button type="button" onClick={generateLinkKey} style={S.genBtn}>LinkKey 생성</button>
                        </div>
                    </div>
                    <button type="submit" disabled={loading} style={S.submitBtn}>
                        {loading ? '등록 중...' : '등록하기'}
                    </button>
                </form>
            </div>
        </div>
    );
};

const S = {
    wrap: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 120px)', padding: '20px' },
    card: {
        width: '100%', maxWidth: '500px', padding: '32px', background: '#fff',
        border: '1px solid #e5e7eb', borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    title: { fontSize: '22px', fontWeight: '700', textAlign: 'center', marginBottom: '20px', color: '#1f2937' },
    form: { display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '4px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
    input: {
        padding: '10px 12px', border: '1px solid #e5e7eb', borderRadius: '8px',
        fontSize: '14px', outline: 'none', boxSizing: 'border-box',
    },
    genBtn: {
        padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: '8px',
        background: '#f3f4f6', cursor: 'pointer', fontSize: '13px', fontWeight: '500',
        whiteSpace: 'nowrap', color: '#374151',
    },
    submitBtn: {
        padding: '12px', border: 'none', borderRadius: '8px', background: '#18181b',
        color: '#fff', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '8px',
    },
    errorBox: {
        padding: '10px', borderRadius: '8px', background: '#fef2f2',
        color: '#dc2626', border: '1px solid #fecaca', fontSize: '14px', textAlign: 'center', marginBottom: '8px',
    },
    successBox: {
        padding: '10px', borderRadius: '8px', background: '#f0fdf4',
        color: '#16a34a', border: '1px solid #bbf7d0', fontSize: '14px', textAlign: 'center', marginBottom: '8px',
    },
};

export default AdminInsertUser;
